import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Row,
} from "reactstrap";

//Context
import { useAuth } from "../../../context/auth";
import { showMessage } from "../../../services/message";

//API
import { api_PUT } from "../../../services/api_service";

export default function InformacoesComplementares({
  item,
  opcao,
  handleProximoStep,
  handleStepAnterior,
}) {
  const { setLoading } = useAuth();
  const [registro, setRegistro] = useState(null);
  const { register, handleSubmit, setValue } = useForm({
    mode: "onBlur",
  });

  useEffect(() => {
    if (item) {
      setRegistro(item);
      const obraData = getObraData();
      if (obraData) setAllValues(obraData);
    }
  }, [item]);

  const getObraData = () => {
    const isRequerimento = opcao.tipoCadastro === "Requerimento";
    const obraList = isRequerimento
      ? item?.requerimentoGerador?.[0]?.requerimentoGeradorObras
      : item?.protocoloGerador?.[0]?.protocoloGeradorObras;

    return obraList?.length ? obraList[0] : null;
  };

  const setAllValues = (obra) => {
    const fields = [
      "praticasDeReciclagem",
      "descricaoEmpreendimento",
      "outrasInformacoes",
    ];
    fields.forEach((field) => {
      if (obra[field]) setValue(field, obra[field], { shouldValidate: true });
    });
  };

  function handleCriarObjetoTipoRequerimento(data) {
    const obra = item?.requerimentoGerador?.[0]?.requerimentoGeradorObras?.[0];
    return {
      ...obra,
      praticasDeReciclagem: data.praticasDeReciclagem,
      descricaoEmpreendimento: data.descricaoEmpreendimento,
      outrasInformacoes: data.outrasInformacoes,
    };
  }

  function handleCriarObjetoTipoProtocolo(data) {
    const obra = item?.protocoloGerador?.[0]?.protocoloGeradorObras?.[0];
    return {
      ...obra,
      praticasDeReciclagem: data.praticasDeReciclagem,
      descricaoEmpreendimento: data.descricaoEmpreendimento,
      outrasInformacoes: data.outrasInformacoes,
    };
  }

  const onSubmit = async (data) => {
    const isRequerimento = opcao.tipoCadastro === "Requerimento";

    if (isRequerimento) {
      setLoading(true);
      try {
        const objRequerimento = handleCriarObjetoTipoRequerimento(data);

        let resposta;

        resposta = await api_PUT(
          "RequerimentoGerador/PutRequerimentoGeradorObra/informacoescomplementares",
          objRequerimento
        );

        const novaObra = resposta?.data;
        const registroAtualizado = { ...registro };

        if (registroAtualizado.requerimentoGerador?.[0]) {
          registroAtualizado.requerimentoGerador[0].requerimentoGeradorObras = [
            novaObra,
          ];
        }

        handleProximoStep(registroAtualizado);
      } catch (error) {
        showMessage(
          "Error",
          error?.menssage ?? "Operação com error",
          "error",
          null
        );
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(true);
      try {
        const objProtocolo = handleCriarObjetoTipoProtocolo(data);

        let resposta;

        resposta = await api_PUT(
          "ProtocoloGerador/PutProtocoloGeradorObra/informacoescomplementares",
          objProtocolo
        );

        const novaObra = resposta?.data;
        const registroAtualizado = { ...registro };

        if (registroAtualizado.protocoloGerador?.[0]) {
          registroAtualizado.protocoloGerador[0].protocoloGeradorObras = [
            novaObra,
          ];
        }

        handleProximoStep(registroAtualizado);
      } catch (error) {
        showMessage(
          "Error",
          error?.menssage ?? "Operação com error",
          "error",
          null
        );
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <Card className={`card-stats`}>
      <CardBody>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Container style={{ maxWidth: "1000px", margin: "0px auto" }}>
            <h2 className="titulo-solicitacao">Informações Complementares</h2>
            <Row>
              <Col md="12" lg={12}>
                <Row>
                  {/* Práticas de Reciclagem */}
                  <Col md="12">
                    <FormGroup>
                      <b>
                        <label>Práticas de Reciclagem</label>
                      </b>
                      <Input
                        type="textarea"
                        name="praticasDeReciclagem"
                        innerRef={register()}
                        maxLength="2000"
                        rows="3"
                      />
                    </FormGroup>
                  </Col>

                  {/* Descrição do Empreendimento */}
                  <Col md="12">
                    <FormGroup>
                      <b>
                        <label>Descrição do Empreendimento</label>
                      </b>
                      <Input
                        type="textarea"
                        name="descricaoEmpreendimento"
                        innerRef={register()}
                        maxLength="2000"
                        rows="3"
                      />
                    </FormGroup>
                  </Col>

                  {/* Outras Informações */}
                  <Col md="12">
                    <FormGroup>
                      <b>
                        <label>Outras Informações</label>
                      </b>
                      <Input
                        type="textarea"
                        name="outrasInformacoes"
                        innerRef={register()}
                        maxLength="2000"
                        rows="2"
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col lg="6" className="text-left">
                <Button
                  color="secundary"
                  onClick={() => {
                    handleStepAnterior(registro);
                  }}
                  className="btn-mobile"
                  type="submit"
                >
                  <i className="fas fa-chevron-left"></i>
                  Voltar
                </Button>
              </Col>
              <Col lg="6" className="text-right">
                <Button color="success" className="btn-mobile" type="submit">
                  Finalizar <i className="fas fa-save"></i>
                </Button>
              </Col>
            </Row>
          </Container>
        </Form>
      </CardBody>
    </Card>
  );
}
